import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getCanonicalForPath, setCanonicalTag } from '../hooks/useCanonical';

/**
 * CanonicalManager lytter på rute-skift og vedligeholder det self-referencing
 * canonical tag i document.head.
 * 
 * - Hvis den aktuelle rute er en af de godkendte primære sider, indsættes/opdateres
 *   <link rel="canonical" href="https://www.dansktagbyg.dk/..." />
 * - Hvis ruten er en kopi (/c/*, /om-os, /p/* kopier, osv.), en redirect eller en fejlsiden,
 *   fjernes canonical tagget helt.
 */
export default function CanonicalManager() {
  const location = useLocation();

  useEffect(() => {
    const canonicalUrl = getCanonicalForPath(location.pathname);
    setCanonicalTag(canonicalUrl);
  }, [location.pathname]);

  return null;
}
